import Cookies from 'js-cookie';
import { updateLocalStorageDataForPayment } from '../../Utils/addressUtils';
import { getCountry } from '../../Utils/ForeignUtils';
import { mobileRegexUAE, UAECountryCode } from './constant';
import { getCartItems } from '../../Utils/helper';
import { OvalunaPrepaidIds } from '../../Constants/PaymentPage';
import platform from 'platform';

export const MobileValidator = (mobile) => {
  const country = getCountry();
  switch (country) {
    case 'uae':
      return MobileValidatorUAE(mobile);
    default:
      return MobileValidatorIndia(mobile);
  }
};

export const MobileValidatorIndia = (mobile) => {
  if (new RegExp('[6-9]{1}[0-9]{9}').test(mobile)) {
    return true;
  } else {
    return false;
  }
};
export const MobileValidatorUAE = (mobile) => {
  if (mobileRegexUAE.test(UAECountryCode + mobile)) {
    return true;
  } else {
    return false;
  }
};
export const pincodeValidator = (pincode) => {
  if (new RegExp('[0-9]{6}').test(pincode)) {
    return true;
  } else {
    return false;
  }
};
export const emailValidator = (email) => {
  if (
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      email,
    ) ||
    email === ''
  ) {
    return true;
  } else {
    return false;
  }
};

export const getAddressTypeValue = (address) => {
  const value = address['address_type'];
  if (value == 'Home' || value == '1') {
    return '1';
  } else {
    return '2';
  }
};
export const updateIsDefaultKey = (address, addressId, paymentMode) => {
  if (addressId) address['id'] = addressId;
  Cookies.remove('is_default');
  Cookies.set('is_default', JSON.stringify(address), '/');
  if (!Cookies.get('passing_data'))
    return updateLocalStorageDataForPayment(paymentMode);
};

export const checkEmailValidation = (value) => {
  return /^[^\s@]+@[^\s@]+$/.test(value);
};

export const checkEmptyStringValidation = (value) => {
  return value.trim() !== '';
};

export const showPrepaidFlow = () => {
  const cartItems = getCartItems();
  let ovalunaExists = false;
  cartItems?.map((item) => {
    if (OvalunaPrepaidIds?.indexOf(item) > -1) {
      ovalunaExists = true;
    }
  });
  const isIOS = platform?.os?.family == 'iOS';
  return ovalunaExists && !isIOS;
  // return ovalunaExists;
};
